<template>
  <b-overlay :show="show">
    <div class="my-register-page" style="font-size: 13px">
      <div class="my-container">
        <b-row class="mb-2">
          <b-col>
            <h1>{{ pageTitle }}</h1>
          </b-col>
        </b-row>

        <div v-if="!searched" class="cardStyleEdit mb-3" style="padding: 24px">
          <b-row>
            <b-col cols="12">
              <h5 class="styleText mb-3">{{ $t("innOrPinfl") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="8">
              <custom-input
                type="number"
                :placeholder="$t('innOrPinfl')"
                v-model="searchInn"
                :label="$t('innOrPinfl')"
                @keyup.native.enter="SearchByInnOrPinfl"
              ></custom-input>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="d-flex align-items-end">
              <b-button
                variant="primary"
                style="width: 100%"
                :disabled="isSearching"
                @click="SearchByInnOrPinfl"
              >
                <b-spinner v-if="isSearching" small></b-spinner>
                {{ $t("search") }}
              </b-button>
            </b-col>
          </b-row>
        </div>

        <template v-if="searched">
          <div class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ $t("contractor") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12" sm="12" md="6">
                <custom-input
                  disabled
                  type="number"
                  :placeholder="$t('inn')"
                  v-model="Request.contractor.innOrPinfl"
                  :label="$t('inn')"
                ></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6">
                <custom-input
                  disabled
                  :placeholder="$t('name')"
                  v-model="Request.contractor.fullName"
                  :label="$t('name')"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12" sm="12" md="6">
                <custom-input
                  disabled
                  :placeholder="$t('oblast')"
                  v-model="Request.contractor.region"
                  :label="$t('oblast')"
                ></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6">
                <custom-input
                  disabled
                  :placeholder="$t('region')"
                  v-model="Request.contractor.district"
                  :label="$t('region')"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12" sm="12" md="12">
                <custom-input
                  disabled
                  :placeholder="$t('oked')"
                  v-model="Request.contractor.oked"
                  :label="$t('oked')"
                ></custom-input>
              </b-col>
            </b-row>
          </div>

          <div class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ pageTitle }}</h5>
              </b-col>
            </b-row>
            <b-row v-if="isMuloqot" class="mt-2">
              <b-col cols="12">
                <div class="pinfl-search">
                  <custom-input
                    class="pinfl-search__input"
                    type="number"
                    :placeholder="$t('pinfl')"
                    v-model="employeePinfl"
                    :label="$t('pinfl') + ' *'"
                    :maxlength="14"
                    :onlyNumber="true"
                    @keyup.native.enter="SearchEmployeeByPinfl"
                  ></custom-input>
                  <b-button
                    class="pinfl-search__btn"
                    variant="primary"
                    :disabled="isEmployeeSearching"
                    @click="SearchEmployeeByPinfl"
                  >
                    <b-spinner v-if="isEmployeeSearching" small></b-spinner>
                    {{ $t("search") }}
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mt-2">
                <custom-input
                  :placeholder="$t('organization')"
                  v-model="Request.organizationName"
                  :label="$t('organization') + ' *'"
                ></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mt-2">
                <custom-input
                  :placeholder="$t('employee')"
                  v-model="Request.employeeName"
                  :label="$t('employee') + ' *'"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row v-if="isProfilaktika" class="mt-2">
              <b-col cols="12" sm="12" md="6" class="mb-3">
                <div class="my-input-select">
                  <label class="input-color-label">{{ $t("organization") }}</label>
                  <v-select
                    :placeholder="$t('organization')"
                    :options="OrganizationList"
                    :reduce="(item) => item.value"
                    label="text"
                    v-model="Request.organizationId"
                    @input="OnOrganizationChange"
                  ></v-select>
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mb-3">
                <div class="pinfl-search">
                  <custom-input
                    class="pinfl-search__input"
                    type="number"
                    :placeholder="$t('pinfl')"
                    v-model="employeePinfl"
                    :label="$t('pinfl')"
                    :maxlength="14"
                    :onlyNumber="true"
                    @keyup.native.enter="SearchEmployeeByPinflProfilaktika"
                  ></custom-input>
                  <b-button
                    class="pinfl-search__btn"
                    variant="primary"
                    :disabled="isEmployeeSearching"
                    @click="SearchEmployeeByPinflProfilaktika"
                  >
                    <b-spinner v-if="isEmployeeSearching" small></b-spinner>
                    {{ $t("search") }}
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="12" class="mb-3">
                <custom-input
                  disabled
                  :placeholder="$t('employee')"
                  v-model="Request.employeeName"
                  :label="$t('employee')"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12" sm="12" md="12">
                <custom-input
                  :placeholder="$t('visitPurpose')"
                  v-model="Request.visitPurpose"
                  :label="$t('visitPurpose')"
                ></custom-input>
              </b-col>
            </b-row>
          </div>

          <div class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ $t("files") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="file-uploader" @click="TriggerFile">
                  <input
                    ref="fileInput"
                    type="file"
                    class="file-uploader__input"
                    @change="HandleFileChange"
                  />
                  <div class="file-uploader__icon">
                    <b-icon icon="paperclip" font-scale="1.4"></b-icon>
                  </div>
                  <div class="file-uploader__text">
                    <span class="file-uploader__title">{{
                      $t("attachFile")
                    }}</span>
                  </div>
                  <b-spinner
                    v-if="fileUploading"
                    small
                    class="ml-auto"
                  ></b-spinner>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="Request.files.length">
              <b-col>
                <b-table-simple bordered responsive>
                  <b-tbody>
                    <b-tr variant="primary">
                      <b-td>#</b-td>
                      <b-td>{{ $t("fileName") || "File" }}</b-td>
                      <b-td class="text-center" style="width: 80px">
                        {{ $t("actions") }}
                      </b-td>
                    </b-tr>
                    <b-tr
                      v-for="(item, index) in Request.files"
                      :key="item.id"
                      style="background-color: white"
                    >
                      <b-td>{{ index + 1 }}</b-td>
                      <b-td>{{ item.name || item.id }}</b-td>
                      <b-td class="text-center">
                        <b-link @click="RemoveFile(index)">
                          <b-icon font-scale="1.2" icon="trash"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </div>

          <b-row class="mb-3">
            <b-col cols="6">
              <b-button
                @click="back"
                style="width: 150px"
                variant="outline-danger"
              >
                {{ $t("back") }}
              </b-button>
            </b-col>
            <b-col cols="6" style="text-align: right">
              <b-button
                @click="SaveData"
                style="width: 150px"
                variant="outline-success"
                :disabled="isSave"
              >
                <b-spinner v-if="isSave" small></b-spinner>
                {{ $t("save") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import InspectionService from "@/services/inspection.service";
import InspectionBookService from "@/services/inspectionbook.service";
import ManualService from "@/services/manual.service";
import customDatePicker from "../../components/elements/customDatePicker.vue";
import customInput from "../../components/elements/customInput.vue";
import vSelect from "vue-select";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  BRow,
  BCol,
  BButton,
  BTableSimple,
  BTbody,
  BTr,
  BTd,
  BLink,
  BOverlay,
  BSpinner,
  BIcon,
} from "bootstrap-vue";

const APPLICATION_TYPE = {
  profilaktika: 2,
  muloqot: 1,
};

const emptyContractor = () => ({
  id: null,
  innOrPinfl: "",
  fullName: "",
  region: "",
  district: "",
  oked: "",
});

const emptyRequest = () => ({
  docNumber: "",
  docDate: "",
  applicationTypeId: null,
  contractorId: null,
  organizationId: null,
  organizationName:"",
  organizationInn: "",
  employeeName:"",
  employeeId: null,
  personId: null,
  position: "",
  visitPurpose: "",
  contractor: emptyContractor(),
  files: [],
});

export default {
  name: "QrInspectionEdit",
  components: {
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BLink,
    BOverlay,
    BSpinner,
    BIcon,
    customDatePicker,
    customInput,
    vSelect,
  },
  data() {
    return {
      Request: emptyRequest(),
      kind: "",
      show: false,
      searched: false,
      searchInn: "",
      isSearching: false,
      isSave: false,
      employeePinfl: "",
      isEmployeeSearching: false,
      fileUploading: false,
      OrganizationList: [],
    };
  },
  computed: {
    applicationTypeId() {
      return APPLICATION_TYPE[this.kind] || null;
    },
    isMuloqot() {
      return this.kind === "muloqot";
    },
    isProfilaktika() {
      return this.kind === "profilaktika";
    },
    pageTitle() {
      if (this.kind === "profilaktika")
        return this.$t("InspectionProphylactic");
      if (this.kind === "muloqot") return this.$t("InspectionCommunication");
      return "";
    },
  },
  created() {
    this.kind = this.$route.meta.kind || this.$route.query.kind || "";
    this.Request.applicationTypeId = this.applicationTypeId;
    this.LoadOrganizations();
  },
  methods: {
    LoadOrganizations() {
      ManualService.GetRiskAnalysisOrganizationAsSelectList()
        .then((res) => {
          this.OrganizationList = res.data || [];
        })
        .catch(() => {
          this.OrganizationList = [];
        });
    },
    OnOrganizationChange() {
      this.Request.employeeId = null;
      this.Request.employeeName = "";
      this.employeePinfl = "";
    },
    SearchEmployeeByPinflProfilaktika() {
      if (!this.Request.organizationId) {
        this.makeToast(this.$t("organization"), "error");
        return;
      }
      if (!this.employeePinfl) {
        this.makeToast(this.$t("pinfl"), "error");
        return;
      }
      this.isEmployeeSearching = true;
      InspectionService.SearchEmployeeByPinfl(
        this.employeePinfl,
        this.Request.organizationId
      )
        .then((res) => {
          const data = res.data || {};
          this.Request.employeeId = data.employeeId || null;
          this.Request.employeeName = data.fullName || "";
          this.isEmployeeSearching = false;
        })
        .catch((error) => {
          this.isEmployeeSearching = false;
          this.Request.employeeId = null;
          this.Request.employeeName = "";
          if (error.response && error.response.data) {
            this.makeToast(
              error.response.data.errors || error.response.data,
              "error"
            );
          }
        });
    },
    SearchByInnOrPinfl() {
      if (!this.searchInn) {
        this.makeToast(this.$t("innOrPinfl"), "error");
        return;
      }
      this.isSearching = true;
      InspectionBookService.GetByInnOrPinfl(this.searchInn)
        .then((res) => {
          const data = res.data || {};
          const contractor = data.contractor || {};
          this.Request.contractor = {
            id: contractor.id || null,
            innOrPinfl: contractor.innOrPinfl || this.searchInn,
            fullName: contractor.fullName || "",
            region: contractor.region || "",
            district: contractor.district || "",
            oked: contractor.oked || "",
          };
          this.Request.docNumber = data.docNumber || data.requestDocNumber || "";
          this.Request.docDate = data.docDate || "";
          this.Request.contractorId = this.Request.contractor.id;
          this.searched = true;
          this.isSearching = false;
        })
        .catch((error) => {
          this.isSearching = false;
          if (error.response && error.response.data) {
            this.makeToast(
              error.response.data.errors || error.response.data,
              "error"
            );
          }
        });
    },
    SearchEmployeeByPinfl() {
      if (!this.employeePinfl) {
        this.makeToast(this.$t("pinfl"), "error");
        return;
      }
      if (!/^\d{14}$/.test(String(this.employeePinfl))) {
        this.makeToast(this.$t("pinflMustBe14Digits"), "error");
        return;
      }
      this.isEmployeeSearching = true;
      InspectionService.GetPersonFioByPinfl(this.employeePinfl)
        .then((res) => {
          const data = res.data;
          const extractFio = (v) => {
            if (!v) return "";
            if (typeof v === "string") return v;
            if (typeof v === "object")
              return v.fio || v.fullName || v.name || "";
            return "";
          };
          const fio =
            data && typeof data === "object"
              ? extractFio(data.fullNameLat) ||
                extractFio(data.fullName) ||
                extractFio(data.fio) ||
                extractFio(data.name)
              : data || "";
          this.Request.employeeName = fio;
          const src =
            (data && typeof data.fullNameLat === "object" && data.fullNameLat) ||
            (data && typeof data.fullName === "object" && data.fullName) ||
            (data && typeof data === "object" && data) ||
            {};
          if (src.organization) {
            this.Request.organizationName = src.organization;
          }
          this.Request.organizationInn =
            src.organizationInn ||
            (data && typeof data === "object" && data.organizationInn) ||
            "";
          this.Request.personId = src.personId || null;
          this.Request.position = src.position || "";
          this.isEmployeeSearching = false;
        })
        .catch((error) => {
          this.isEmployeeSearching = false;
          if (error.response && error.response.data) {
            this.makeToast(
              error.response.data.errors || error.response.data,
              "error"
            );
          }
        });
    },
    TriggerFile() {
      if (this.fileUploading) return;
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    HandleFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      this.fileUploading = true;
      InspectionService.UploadFile(file)
        .then((res) => {
          let payload = res.data;
          if (Array.isArray(payload)) payload = payload[0];
          const id =
            payload && typeof payload === "object"
              ? payload.id || payload.fileId || payload.Id
              : payload;
          this.Request.files.push({ id: id || null, name: file.name });
          this.fileUploading = false;
          if (this.$refs.fileInput) this.$refs.fileInput.value = "";
        })
        .catch((error) => {
          this.fileUploading = false;
          if (this.$refs.fileInput) this.$refs.fileInput.value = "";
          if (error.response && error.response.data) {
            this.makeToast(
              error.response.data.errors || error.response.data,
              "error"
            );
          }
        });
    },
    RemoveFile(index) {
      const file = this.Request.files[index];
      if (!file) return;
      if (!file.id) {
        this.Request.files.splice(index, 1);
        return;
      }
      InspectionService.DeleteFile(file.id)
        .then(() => {
          this.Request.files.splice(index, 1);
        })
        .catch(() => {
          this.Request.files.splice(index, 1);
        });
    },
    SaveData() {
      if (!this.Request.contractorId) {
        this.makeToast(this.$t("contractor"), "error");
        return;
      }
      if (this.isMuloqot) {
        const errors = [];
        const pinfl = String(this.employeePinfl || "").trim();
        if (!pinfl) errors.push(this.$t("pinfl"));
        else if (!/^\d{14}$/.test(pinfl))
          errors.push(this.$t("pinflMustBe14Digits"));
        if (!String(this.Request.organizationName || "").trim())
          errors.push(this.$t("organization"));
        if (!String(this.Request.employeeName || "").trim())
          errors.push(this.$t("employee"));
        if (errors.length) {
          this.makeToast(
            this.$t("fillRequiredFields") +
              "\n" +
              errors.map((e, i) => i + 1 + ". " + e).join("\n"),
            "error"
          );
          return;
        }
      }
      this.isSave = true;
      const data = {
        docNumber: this.Request.docNumber,
        docDate: this.Request.docDate,
        applicationTypeId: this.applicationTypeId,
        contractorId: this.Request.contractorId,
        organizationId: this.isProfilaktika ? this.Request.organizationId : null,
        employeeId: this.isProfilaktika ? this.Request.employeeId : null,
        organizationName: this.isMuloqot ? this.Request.organizationName : "",
        organizationInn: this.isMuloqot ? this.Request.organizationInn : "",
        employeeName: this.isMuloqot ? this.Request.employeeName : "",
        personId: this.isMuloqot ? this.Request.personId : null,
        position: this.isMuloqot ? this.Request.position : "",
        visitPurpose: this.Request.visitPurpose,
        files: this.Request.files
          .filter((f) => f.id)
          .map((f) => ({ id: f.id })),
      };
      InspectionService.Create(data)
        .then(() => {
          this.isSave = false;
          this.makeToast(this.$t("SendSuccess"), "success");
          this.$router.push({ name: "BiznesHimoya" });
        })
        .catch((error) => {
          this.isSave = false;
          if (error.response && error.response.data) {
            this.makeToast(
              error.response.data.errors || error.response.data,
              "error"
            );
          }
        });
    },
    back() {
      this.$router.go(-1);
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400) {
        const errors = Object.values(message.errors);
        a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cardStyleEdit {
  padding: 16px;
  background-color: #eaf2ff;
  border-radius: 8px;
}
.styleText {
  font-weight: 900;
}

.pinfl-search {
  display: flex;
  align-items: stretch;
  width: 100%;

  &__input {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__btn {
    flex: 0 0 auto;
    margin-left: 8px;
    border-radius: 12px;
    padding: 0 20px;
    font-size: 14px;
    white-space: nowrap;
  }
}

.my-input-select {
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 12px;
  padding-top: 8px;

  .input-color-label {
    display: block;
    width: 100%;
    padding-left: 16px;
    padding-top: 4px;
    text-transform: uppercase;
    font-size: 12px;
    color: #8b95a7;
    margin-bottom: 0;
  }

  ::v-deep .v-select {
    .vs__dropdown-toggle {
      background-color: #f7f7f7;
      border: none;
      border-radius: 12px;
      padding: 0 8px 6px;
      min-height: 36px;
      box-shadow: none;
    }
    .vs__search,
    .vs__search:focus {
      margin: 0;
      padding-left: 8px;
      font-size: 14px;
    }
    .vs__selected {
      margin-left: 8px;
      margin-top: 0;
      font-size: 14px;
      color: #333;
    }
    .vs__selected-options {
      padding: 0;
    }
    .vs__actions {
      padding-right: 10px;
    }
    .vs__dropdown-menu {
      border-radius: 12px;
      border: none;
      box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
    }
  }
}

.file-uploader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background-color: #f7f7f7;
  border: 1.5px dashed #c8d2e5;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: #3f75fe;
    background-color: #eef3ff;
  }

  &__input {
    display: none;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #e7eeff;
    color: #3f75fe;
  }

  &__title {
    font-weight: 600;
    color: #293958;
    font-size: 14px;
  }
}
</style>
